import { useMemo } from 'react';
import { useGetDamagePartImageData } from './api/useGetDamagePartImageData';
import { DAMAGE_PART } from '@/consts/bodyAndPaint';
import { RepairDamagedImageInfoType } from '@/types/bodyAndPaint';

interface RepairDamagedImageDataHoopProps {
  inspectionID: number;
}
export const useRepairDamagedImageData = ({
  inspectionID,
}: RepairDamagedImageDataHoopProps) => {
  const { damagePartList } = useGetDamagePartImageData({
    t_pm_car_inspection_id: inspectionID,
  });

  // 損傷画像リスト
  const damagedImageListData: RepairDamagedImageInfoType[] = useMemo(
    () =>
      damagePartList?.reduce((list, item) => {
        const imageItem = item as { [key: string]: any };

        const valid = 1;
        const damagePart = Object.keys(DAMAGE_PART)
          .filter((key) => key in imageItem && imageItem[key] === valid)
          .map((key) => DAMAGE_PART[key as keyof typeof DAMAGE_PART]);

        const repairList = item?.maintenance_lists.map(
          (item) => item.maintenance_name,
        );
        const imageList = item?.image_lists.map((item) => item.image_file_path);
        const estimateItem: RepairDamagedImageInfoType = {
          damage_part: damagePart,
          damage_desc: item?.damage_detail,
          repair_item_list: repairList,
          image_url_list: imageList,
        };
        list.push(estimateItem);
        return list;
      }, [] as RepairDamagedImageInfoType[]) ?? [],
    [damagePartList],
  );

  return { damagedImageListData };
};
